import { useCallback, useEffect, useState } from "react";

import useEmailParam from "@/v1/components/hooks/useEmailParam";
import type { UserFilterOptions } from "@/v1/components/pages/Mandanten/Common/UserFilters";
import type { IUser } from "@/v1/types";
import { destroyMessage, showLoadingMessage } from "@/v1/utils";
import api from "@/v1/api";

const LOADING_MESSAGE_KEY = "finding-user";

export const useFilteredUser = () => {
  const [emailParam, setEmailParam] = useEmailParam();
  const [filterOptions, setFilterOptions] = useState<UserFilterOptions>({
    search: emailParam || "",
    all: false,
  });
  const [user, setUser] = useState<IUser | undefined>();

  const fetchUser = useCallback(async (email: string) => {
    if (!email) {
      return;
    }
    showLoadingMessage(LOADING_MESSAGE_KEY);
    try {
      const user = await api.kontax.getUserByEmail(email);
      setUser(user);
    } catch (error) {
      setUser(undefined);
    } finally {
      destroyMessage(LOADING_MESSAGE_KEY);
    }
  }, []);

  useEffect(() => {
    if (emailParam) {
      fetchUser(emailParam);
    } else {
      setUser(undefined);
    }
  }, [emailParam, fetchUser]);

  useEffect(() => {
    setEmailParam(filterOptions.search || undefined);
  }, [filterOptions, setEmailParam]);

  return {
    user,
    filterOptions,
    setFilterOptions,
  };
};
